module.exports = {
  language: 'Язык',
  selectLanguage: 'Выбрать язык',
  charging: 'Заряжается',
  notCharging: 'Не заряжается',
  advanceSetting: 'расширенные настройки',
  chargingDesc: 'Начать зарядку когда уровень батареи ниже чем ',
  enabled: 'Включено',
  disabled: 'Выключено',
  onPowerRestore: 'При восстановлении питания',
  powerWakeDesc: '** Пожалуйста, используйте два независимых зарядных устройста USB для питания Pi и PiSugar соответственно, и держите переключатель питания PiSugar включенным. Устройство автоматически включится когда внешнее питание будет восстановлено.',
  powerWakeDescFor3: 'PiSugar автоматически включится при восстановлении внешнего питания.',
  powerWakeOffWarning: 'Вы отключили функцию пробуждения при восстановлении питания, пожалуйста, не подавайте отдельно внешнее питание на Raspberry Pi.',
  powerWakeOffTitle: 'Замечание',
  confirmButtonText: 'Понятно',
  wakeUpFeature: 'Запланировать включение',
  repeat: 'Повторять',
  repeatEveryday: 'повторять каждый день.',
  repeatOn: 'повторять в',
  checkAll: 'Выбрать всё',
  clearAll: 'Очистить всё',
  wakeUpDesc: 'Запланировать включение в ',
  wakeUpOffDesc: 'Автоматическое включение не настроено.',
  buttonFunction: 'Нажатие кнопки',
  singleTapLabel: 'Одиночное',
  doubleTapLabel: 'Двойное',
  longTapLabel: 'Удерживать',
  singleTap: 'одиночное нажатие',
  doubleTap: 'двойное нажатие',
  longTap: 'удерживать',
  none: 'Ничего',
  edit: 'Изм.',
  customShell: 'Shell команда',
  shutdown: 'Выключить',
  shellModalTitle: {
    single: 'Команда при одиночном нажатии кнопки',
    double: 'Команда при двойном нажатии кнопки',
    long: 'Команда при удержании кнопки'
  },
  shell: 'Shell',
  shellPlaceholder: 'введите shell-команду...',
  cancel: 'Отмена',
  confirm: 'Подтвердить',
  triggered: 'Активировано',
  safeShutdown: 'Безопасное выключение',
  batteryLevel: 'Уровень Заряда',
  immediately: 'Немедленно',
  secondsDelay: 'секунды задержка',
  rtcTime: 'RTC время',
  sysTime: 'SYS время',
  syncTime: 'Синхронизировать время',
  weekDay: {
    Monday: 'Понедельник',
    Tuesday: 'Вторник',
    Wednesday: 'Среда',
    Thursday: 'Четверг',
    Friday: 'Пятница',
    Saturday: 'Суббота',
    Sunday: 'Воскресенье'
  },
  weekDayShort: {
    Mon: 'Пн',
    Tue: 'Вт',
    Wed: 'Ср',
    Thu: 'Чт',
    Fri: 'Пт',
    Sat: 'Сб',
    Sun: 'Вс'
  },
  batteryInputProtect: 'Защита входа батареи',
  batteryInputProtectDesc: 'Процесс зарядки остановится, когда будет достигнуто 60-80% заряда батареи, что может эффективно продлить срок службы батареи.',
  antiMistouch: 'Анти прикосновение',
  antiMistouchDesc: 'После того, как защита от прикосновения включена, переключатель необходимо щелкнуть + длительное нажатие для срабатывания.',
  softPoweroff: 'Мягкое отключение',
  softPoweroffDesc: 'Использование кнопки переключения для выключения не приведет к прямому отключению питания, команда выключения будет выдана программным обеспечением.',
  softPoweroffShell: 'Оболочка мягкого отключения',
  softPoweroffShellDesc: 'Оболочка для выполнения при срабатывании события мягкого отключения.',
  changeLoginPassword: 'Изменить пароль для входа',
  username: 'имя пользователя',
  password: 'пароль',
  passwordConfirm: 'Пожалуйста, введите пароль еще раз',
  usernameCannotBeEmpty: 'Имя пользователя не может быть пустым',
  passwordCannotBeEmpty: 'пароль не может быть пустым',
  passwordNotConsistent: 'Введенный дважды пароль должен совпадать',
  usernameWithSpace: 'Имя пользователя не может содержать пробелов',
  passwordWithSpace: 'Пароль не может содержать пробелов',
  changePasswordSuccess: 'Модификация завершена.',
  loginDialog: 'Вход',
  login: 'Войти'
}



// WEBPACK FOOTER //
// ./src/locale/ru-RU.js